import { RadioGroup } from '@/components/RadioGroup';
import {
    EQuickQuoteFinanceType,
    setBusinessFinanceType,
} from '@/context/borrower';
import { useAppDispatch } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'BusinessFinanceType';

export function BusinessFinanceType({
    baseId,
    showErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    // const currentState = useAppSelector(selectBusinessFinanceType);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        dispatch(setBusinessFinanceType(value as EQuickQuoteFinanceType));
    }

    // ***** Render *****
    const options = [
        // {
        //     label: 'Secured',
        //     value: EQuickQuoteFinanceType.BUSINESS_SECURED,
        //     id: `${baseId}-button-businessFinanceType-secured`,
        // },
        // {
        //     label: 'Unsecured',
        //     value: EQuickQuoteFinanceType.BUSINESS_UNSECURED,
        //     id: `${baseId}-button-businessFinanceType-unsecured`,
        // },
    ];
    return (
        <div data-testid={testId}>
            <RadioGroup
                title='Is the loan Secured or Unsecured?'
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={undefined}
            />
        </div>
    );
}
